import React, { Component } from 'react';
import DrawerCustom from '../../components/DrawerCustom';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles'
import { Grid } from '@material-ui/core';
import CustomTypo from '../../components/CustomTypo';
import { RadioCheckedIcon, RadioIcon, VisaIcon, MasterIcon, PaypalIcon, VNPayIcon } from '../../components/icons'
import CustomizedCircularProgress from '../../components/CircularProgress';
import ButtonCustom from '../../components/ButtonCustom';
import { BackOnPrimaryIcon } from '../../components/icons';
import { getAppCfg } from '../../utils/common';
import { connection, domainName, portal_config } from '../../../portal.config';
import Paypal from '../../components/Paypal';
const styles = theme => ({
    container: {
        padding: theme.spacing(6),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(6, 3, 3, 3)
        }
    },
    cart_content: {
        marginTop: theme.spacing(20)
    },
    buttonBack: {
        width: theme.spacing(10),
        height: theme.spacing(10),
        backgroundColor: theme.palette.background.tertiary,
        borderRadius: theme.spacing(8),
        cursor: "pointer",
        textAlign: "center",
        touchAction: "manipulation",
        position: 'absolute',
        top: theme.spacing(5),
        right: theme.spacing(5),
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    method_container: {
        padding: theme.spacing(4, 0, 0, 0)
    },
    method: {
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(2),
        height: theme.spacing(20),
        padding: theme.spacing(1, 6, 1, 6),
        cursor: 'pointer',
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1, 3, 1, 3),
        }
    },
    button: {
        padding: theme.spacing(6)
    }
})
function SelectPaymentMethodView(props) {
    const { classes, t, onChangeCard, payment_method, onSelectPaymentMethod, showLoading, onAddCard, onNext } = props
    const app_config = getAppCfg()
    const allowed_payment_methods = app_config && app_config.allowed_payment_methods ? app_config.allowed_payment_methods : []
    var support_payment_card = false
    var support_payment_cash = false
    for (var i = 0; i < allowed_payment_methods.length; i++) {
        if (allowed_payment_methods[i].payment_method_type && allowed_payment_methods[i].payment_method_type === 'CARD') {
            support_payment_card = true
        }
        if (allowed_payment_methods[i].payment_method_type && allowed_payment_methods[i].payment_method_type === 'CASH') {
            support_payment_cash = true
        }
    }
    console.log("props.payment_method_types = ", props.payment_method_types)
    return (
        <div>
            <DrawerCustom open={props.open} onClose={props.onClose}
                fullScreen
                children={
                    <Grid item className={classes.container}>
                        <Grid xs={12} item container justify='flex-end' onClick={() => props.onClose()}>
                            <Grid color='gray' className={classes.buttonBack}>
                                <BackOnPrimaryIcon />
                            </Grid>
                        </Grid>
                        <Grid xs={12} item className={classes.cart_content}>
                            <CustomTypo mg_top_lg variant='h3' color='onPrimary'>{t('select_payment_method')}</CustomTypo>
                        </Grid>

                        <Grid xs={12} item>
                            {showLoading && <CustomizedCircularProgress />}
                            {props.payment_method_types && props.payment_method_types.map((type, index) => {
                                if (type != 'WALLET' && type != 'VNPAY') {
                                    return (
                                        <Grid xs={12} key={index} item>
                                            <Grid xs={12} item className={classes.method_container} onClick={() => onSelectPaymentMethod(type)}>
                                                <Grid xs={12} item className={classes.method} container alignItems='center' >
                                                    <Grid xs={1} sm={1} item>
                                                        {payment_method === type ? <RadioCheckedIcon /> : <RadioIcon />}
                                                    </Grid>
                                                    <Grid xs={1} sm={1} item>
                                                        <CustomTypo mg_left_xs variant='body1'>{type === 'CARD' ? t('cards') : t('cash')}</CustomTypo>
                                                    </Grid>
                                                    {type === 'CARD' && <Grid xs={6} sm={7} item container justify='center'>
                                                        {props.primary_card && <CustomTypo mg_left_xs variant='body1'>**** **** **** {props.primary_card.card.last4}</CustomTypo>}
                                                    </Grid>}
                                                    {type === 'CARD' && props.primary_card && <Grid xs={2} sm={2} item container justify='flex-end'><VisaIcon /></Grid>}
                                                    {type === 'CARD' && props.primary_card && <Grid xs={2} sm={1} item container justify='flex-start'><MasterIcon /></Grid>}
                                                    {type === 'CARD' && !props.primary_card && <Grid xs={4} sm={3} item container justify='flex-end'><CustomTypo onClick={onAddCard}>+ {t('add_a_card')}</CustomTypo></Grid>}

                                                </Grid>
                                            </Grid>
                                            {type === 'CARD' && <Grid xs={12} item container justify='flex-end' style={{ cursor: 'pointer' }}><CustomTypo mg_top_md onClick={onChangeCard} color='onPrimary'>{t('manage_card')}</CustomTypo></Grid>}
                                        </Grid>
                                    )
                                }
                            })}
                            {connection.crmConfig.isOpenPaypal && <Grid xs={12} item>
                                <Grid xs={12} item className={classes.method_container} onClick={() => onSelectPaymentMethod("WALLET")}>
                                    <Grid xs={12} item className={classes.method} container alignItems='center' >
                                        <Grid xs={1} sm={1} item>
                                            {payment_method === "WALLET" ? <RadioCheckedIcon /> : <RadioIcon />}
                                        </Grid>
                                        <Grid xs={2} item>
                                            <PaypalIcon style={{ width: 80, height: 40, objectFit: 'contain' }} />

                                        </Grid>

                                        <Grid xs={9} item justifyContent='flex-end' container>
                                            <CustomTypo variant='body1'> {props.primary_paypal && props.primary_paypal.wallet && props.primary_paypal.wallet.email ? props.primary_paypal.wallet.email : ''}</CustomTypo>
                                        </Grid>

                                    </Grid>
                                </Grid>

                            </Grid>}
                            {portal_config.isLocationVN && <Grid xs={12} item>
                                <Grid xs={12} item className={classes.method_container} onClick={() => onSelectPaymentMethod("VNPAY")}>
                                    <Grid xs={12} item className={classes.method} container alignItems='center' >
                                        <Grid xs={1} sm={1} item>
                                            {payment_method === "VNPAY" ? <RadioCheckedIcon /> : <RadioIcon />}
                                        </Grid>
                                        <Grid xs={2} item>
                                            <VNPayIcon style={{ width: 80, height: 40, objectFit: 'contain' }} />
                                        </Grid>

                                        <Grid xs={9} item justifyContent='flex-end' container>
                                        </Grid>

                                    </Grid>
                                </Grid>
                            </Grid>}
                            <Grid item className={classes.button}>
                                <ButtonCustom fullWidth disabled={payment_method === 'CARD' && !props.primary_card} color='primary' onClick={() => onNext()}>{t('btn_next')}</ButtonCustom>
                            </Grid>
                        </Grid>
                    </Grid>

                }
            />
        </div>
    );
}

export default withStyles(styles)(withTranslation()(SelectPaymentMethodView));